import React from "react";
import styles from "./FooterNotes.module.scss";
import { WSText } from "@wingspanhq/fe-component-library";

export interface FooterNotesProps {}

export const FooterNotes: React.FC<FooterNotesProps> = ({ children }) => (
  <WSText.ParagraphXs className={styles.base}>{children}</WSText.ParagraphXs>
);
